<script setup lang="ts">
/**
 * Streama CMS UI · Root component
 *
 * Dispatches between layouts:
 *   - meta.layout === 'auth'  → bare; LoginView renders standalone.
 *   - meta.layout === 'blank' → bare; e.g. embed views (none yet).
 *   - else                    → AppShell with sidebar + topbar.
 *
 * Toast is mounted at root so any view (including login) can push
 * notifications.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppShell from '@/components/layout/AppShell.vue'
import Toast from '@/components/ui/Toast.vue'

const route = useRoute()

const layout = computed(() => {
  return (route.meta.layout as string | undefined) ?? 'shell'
})
</script>

<template>
  <AppShell v-if="layout === 'shell'">
    <RouterView />
  </AppShell>
  <RouterView v-else />

  <Toast />
</template>
